export default __webpack_public_path__ + "static/media/Bg1.fe724f46.jpg";